import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../spinner/spinner.service';

export const SpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldExcludeSpinner = req.headers.has('no-spinner');
  const spinnerService = inject(SpinnerService);
  if (!shouldExcludeSpinner) {
    spinnerService.show();
  }

  let modifiedHeaders = req.headers;
  modifiedHeaders = modifiedHeaders.delete('no-spinner');
  const modifiedReq = req.clone({
    headers: modifiedHeaders,
  });

  return next(modifiedReq).pipe(
    finalize(() => {
      if (!shouldExcludeSpinner) {
        spinnerService.hide();
      }
    })
  );
};
